import clsx from "clsx";
import shape from "../../assets/img/shapes/plane-shape-02.webp";


const PlaneShape02 = ( props:any ) => {

    return (
        <div className={clsx("rmdr-plane-shape-02", props.className)}>
            <img src={shape} alt="rmdr-plane-shape-02" loading="lazy" width={111} height={63} />
        </div>
    )

}

export default PlaneShape02;
